import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import heroPrincipal from '../assets/home/hero-principal-600x450.png';
import sistemaCompleto from '../assets/home/sistema-completo-600x450.png';

const Home = () => {
  return (
    <div className="page">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>TecnoVigilancia 360 | Cámaras de Seguridad en Coacalco | Videovigilancia Profesional</title>
        <meta
          name="description"
          content="Instalación y renta de cámaras de seguridad en Coacalco, Estado de México. Videovigilancia profesional para hogares y negocios. Sistemas CCTV, GPS para vehículos. Cotiza sin compromiso."
        />
        <meta
          name="keywords"
          content="cámaras de seguridad, videovigilancia Coacalco, instalación cámaras, renta cámaras vigilancia, CCTV Estado de México, seguridad hogares negocios, cámaras HD, GPS vehículos, sistemas seguridad profesionales"
        />
        <meta property="og:title" content="TecnoVigilancia 360 - Protección total, visión sin límites" />
        <meta property="og:description" content="Especialistas en sistemas de seguridad y videovigilancia en Coacalco. Instalación, renta y mantenimiento de cámaras HD." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://tecnovigilancia360.com/" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">TecnoVigilancia 360</h1>
          <p className="hero-slogan">Protección total, visión sin límites.</p>
          <p className="hero-description">
            Somos tu mejor opción en <strong>sistemas de seguridad y videovigilancia en Coacalco</strong>.
            Ofrecemos <strong>instalación de cámaras de seguridad</strong>, renta y mantenimiento de
            sistemas CCTV con tecnología de vanguardia para proteger lo que más valoras: tu hogar,
            negocio o flotilla vehicular.
          </p>

          <div className="hero-buttons">
            <Link to="/services" className="btn btn-primary">
              Ver Servicios
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              Contáctanos
            </Link>
          </div>
        </div>

        <div className="hero-image">
          <img
            src={heroPrincipal}
            alt="Instalación profesional de cámaras de seguridad en Coacalco - TecnoVigilancia 360"
            style={{ width: '100%', height: 'auto', borderRadius: '8px', objectFit: 'cover' }}
          />
        </div>
      </section>

      {/* Introducción */}
      <section className="intro-section">
        <div className="container">
          <h2 className="section-title">Expertos en Videovigilancia y Seguridad Electrónica</h2>
          <p className="section-text">
            Somos una empresa especializada en <strong>soluciones de seguridad para hogares y negocios</strong>
            ubicada en Coacalco, Estado de México. Con años de experiencia en el sector, nos dedicamos
            a brindar tranquilidad y protección a nuestros clientes a través de <strong>sistemas de
            videovigilancia de última generación</strong> y <strong>cámaras HD de alta resolución</strong>.
          </p>
          <p className="section-text">
            Nuestro compromiso es ofrecer <strong>servicios de calidad con soporte técnico
            especializado</strong>, equipos modernos y atención personalizada para cada necesidad.
            Ya sea para tu hogar, negocio, local comercial o flotilla de vehículos, tenemos la
            solución perfecta de <strong>CCTV y sistemas de seguridad profesionales</strong> para ti.
          </p>

          {/* Imagen secundaria: Sistema de videovigilancia instalado */}
          <div style={{ marginTop: '3rem', marginBottom: '2rem' }}>
            <img
              src={sistemaCompleto}
              alt="Sistema de videovigilancia CCTV completo instalado en negocio - TecnoVigilancia 360"
              style={{ width: '100%', height: 'auto', maxHeight: '400px', objectFit: 'cover', borderRadius: '8px' }}
            />
          </div>

          <div className="intro-features">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Profesionales Certificados</h3>
              <p>Personal técnico especializado en instalación de cámaras de seguridad</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Equipos Confiables</h3>
              <p>Cámaras HD y sistemas CCTV de alta calidad garantizados</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Servicio Rápido</h3>
              <p>Instalación express y soporte técnico inmediato en Coacalco</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">¿Listo para Proteger tu Patrimonio con Videovigilancia Profesional?</h2>
          <p className="cta-text">
            Contáctanos hoy mismo y recibe una cotización sin compromiso para tu sistema de
            seguridad en Coacalco y zonas aledañas del Estado de México
          </p>
          <Link to="/contact" className="btn btn-cta">
            Solicitar Cotización Gratuita
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
